// src/components/Nav.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export function Nav() {
  return (
    <nav style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '16px 32px', borderBottom: '1.5px solid var(--sand-border)',
      background: 'var(--sand-bg)', position: 'sticky', top: 0, zIndex: 100,
    }}>
      <Link to="/workflows" style={{ display: 'flex', alignItems: 'baseline', gap: 2, textDecoration: 'none' }}>
        <span style={{
          fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700,
          color: 'var(--sand-text)', letterSpacing: '-0.5px',
        }}>
          Comfy<span style={{ color: 'var(--sand-amber)' }}>Stack</span>
        </span>
        <span style={{
          width: 6, height: 6, borderRadius: '50%', background: 'var(--sand-amber-mid)',
          display: 'inline-block', marginLeft: 3, marginBottom: 4,
        }} />
      </Link>
      <span style={{
        fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
        padding: '3px 9px', borderRadius: 20,
        background: 'var(--sand-amber-light)', color: 'var(--sand-amber-dark)',
        border: '1px solid var(--sand-amber-border)', letterSpacing: '0.5px',
      }}>v1.0 · open resource</span>
    </nav>
  );
}

// ── Slogan strip ──────────────────────────────────────────────────────────────
export function SloganStrip({ text }) {
  return (
    <div style={{ padding: '14px 32px 0' }}>
      <div className="fade-up" style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '10px 16px', background: 'var(--sand-surface)',
        border: '0.5px solid var(--sand-border)', borderRadius: 'var(--radius-md)',
      }}>
        <div style={{
          width: 3, minHeight: 28, background: 'var(--sand-amber)',
          borderRadius: 2, flexShrink: 0,
        }} />
        <p style={{
          fontFamily: "'Source Serif 4', serif", fontStyle: 'italic',
          fontSize: 15, color: 'var(--sand-amber)', lineHeight: 1.5,
        }}>{text}</p>
      </div>
    </div>
  );
}

// ── Tag chip ──────────────────────────────────────────────────────────────────
export function Tag({ label }) {
  const styles = {
    new:    { bg: 'var(--sand-teal-bg)',    color: '#5eead4', border: 'var(--sand-teal-border)' },
    beta:   { bg: 'var(--sand-purple-bg)', color: 'var(--sand-purple)', border: 'var(--sand-purple-border)' },
    stable: { bg: '#0e1e30',               color: '#4a7090',  border: '#1e3050' },
    popular:{ bg: 'var(--sand-amber-light)',color: 'var(--sand-amber-dark)', border: 'var(--sand-amber-border)' },
    video:  { bg: 'var(--sand-teal-bg)',   color: '#5eead4',  border: 'var(--sand-teal-border)' },
    default:{ bg: 'var(--sand-bg)',        color: 'var(--sand-muted)', border: 'var(--sand-border)' },
  };
  const s = styles[label] || styles.default;
  return (
    <span style={{
      fontFamily: "'JetBrains Mono', monospace", fontSize: 9,
      padding: '2px 7px', borderRadius: 10,
      background: s.bg, color: s.color, border: `0.5px solid ${s.border}`,
    }}>{label}</span>
  );
}

// ── Section header ────────────────────────────────────────────────────────────
export function SectionHeader({ title, count }) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 16 }}>
      <h2 style={{
        fontFamily: "'Playfair Display', serif", fontSize: 20,
        fontWeight: 600, color: 'var(--sand-text)',
      }}>{title}</h2>
      {count !== undefined && (
        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: 'var(--sand-hint)' }}>
          {count}
        </span>
      )}
    </div>
  );
}

// ── Loading skeleton ──────────────────────────────────────────────────────────
export function LoadingRow() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {[1,2,3].map(i => (
        <div key={i} style={{
          height: 64, background: 'var(--sand-border)', borderRadius: 'var(--radius-md)',
          opacity: 0.4, animation: 'fadeUp 0.3s ease both',
        }} />
      ))}
    </div>
  );
}

// ── Back button ───────────────────────────────────────────────────────────────
export function BackButton({ onClick }) {
  return (
    <button onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 6, marginBottom: 24,
      background: 'none', border: 'none', padding: 0,
      fontFamily: "'Source Serif 4', serif", fontSize: 13,
      color: 'var(--sand-muted)', cursor: 'pointer',
    }}>
      <span style={{ fontSize: 16 }}>←</span> Back to workflows
    </button>
  );
}
